import React, { useState, useEffect } from "react";
import "./index.css";
import api from "api";
import { formatNumber } from "utils/NumberUtils";
import { TableExtend } from "shared";
import t from "utils/Lang";

interface SitePerformanceEstimationProps {
  siteId: number;
}

export default function SitePerformanceEstimation({
  siteId,
}: SitePerformanceEstimationProps) {
  const [dataPerformanceEstimation, setDataPerformanceEstimation] =
    useState<any>({
      tableData: [],
      tableMapping: [],
    });

  const getAISitePerformancePrediction = async () => {
    if (!siteId) return;
    const tableMapping = dataPerformanceEstimation.tableMapping;
    tableMapping[1] = {
      ...tableMapping[1],
      label: t().site_summary_tab__calculating,
    };
    setDataPerformanceEstimation({
      ...dataPerformanceEstimation,
      tableMapping,
    });
    const response: any = await api.getAISitePerformancePrediction(siteId);
    tableMapping[1] = {
      ...tableMapping[1],
      label: t().site_summary_tab__prediction,
    };
    const existedEstimation = response?.result?.data;
    const tableData = dataPerformanceEstimation.tableData.map((dt: any) => ({
      ...dt,
      estimate_prediction: getValueEstimation(dt.code, existedEstimation),
    }));
    setDataPerformanceEstimation({
      ...dataPerformanceEstimation,
      tableData,
      tableMapping,
    });
    if (response.status === "fail") {
      alert(response.message);
    }
  };

  const getValueEstimation = (code: string, data: any) => {
    switch (code) {
      case "personal_site_revenue_per_month_estimation":
        return formatNumber(
          data?.final_forecasted_revenue_per_month_value || 0,
          "0,0"
        );
      case "personal_site_ebitda_per_month_estimation":
        return formatNumber(data?.estimated_ebitda_value || 0, "0,0");
      case "estimated_ebitda_over_revenue_pct":
        return formatNumber(
          data?.estimated_ebitda_over_revenue_pct || 0,
          "0.00%"
        );
      case "estimated_rental_over_revenue_pct":
        return formatNumber(data?.rental_cost_pct || 0, "0.00%");
      default:
        return "0";
    }
  };

  const getData = async () => {
    const [responseEstimation, responseExistingEstimation] = await Promise.all([
      api.getEstimation(siteId),
      api.getExistingAiEstimation(siteId),
    ]);
    console.log('Chỗ này nè...');
    const existedEstimation = responseExistingEstimation?.result?.data;
    let tableData = responseEstimation?.fields_info?.map((field: any) => {
      return {
        code: field.code,
        estimate_label: field.name,
        estimate_prediction: getValueEstimation(field.code, existedEstimation),
        min: field?.items?.[0],
        max: field?.items?.[1],
        avg: field?.items?.[2],
      };
    });
    const extraRow = [
      { id: "00", label: "", colSpan: 1 },
      { id: "01", label: "AI Model", colSpan: 1 },
    ];
    const tableMapping = [
      {
        id: "0",
        label: "",
        mappingKeys: ["estimate_label"],
        isActive: true,
      },
      {
        id: "1",
        label: t().site_summary_tab__prediction,
        mappingKeys: ["estimate_prediction"],
        isActive: true,
        renderAsButton: true,
      },
    ];
    responseEstimation?.result?.map((resEstimation: any, index: number) => {
      tableData = tableData.map((td: any) => {
        return {
          ...td,
          [`estimate_personal_min_${index}`]: formatNumber(
            resEstimation[`${td?.min?.code}`],
            td?.min?.format
          ),
          [`estimate_personal_max_${index}`]: formatNumber(
            resEstimation[`${td?.max?.code}`],
            td?.max?.format
          ),
          [`estimate_personal_avg_${index}`]: formatNumber(
            resEstimation[`${td?.avg?.code}`],
            td?.avg?.format
          ),
        };
      });
      extraRow.push({
        colSpan: 3,
        id: `0${index + 2}`,
        label: `${resEstimation?.created_by?.first_name} ${resEstimation?.created_by?.last_name}`,
      });
      tableMapping.push(
        {
          id: `${index * 3 + 2}`,
          label: "Min",
          mappingKeys: [`estimate_personal_min_${index}`],
          isActive: true,
        },
        {
          id: `${index * 3 + 3}`,
          label: "Max",
          mappingKeys: [`estimate_personal_max_${index}`],
          isActive: true,
        },
        {
          id: `${index * 3 + 4}`,
          label: "Avg",
          mappingKeys: [`estimate_personal_avg_${index}`],
          isActive: true,
        }
      );
    });
    setDataPerformanceEstimation({ tableData, tableMapping, extraRow });
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <TableExtend
      responsive
      striped
      tableData={dataPerformanceEstimation.tableData}
      tableMapping={dataPerformanceEstimation.tableMapping}
      extraRow={dataPerformanceEstimation.extraRow}
      onHeadClick={getAISitePerformancePrediction}
    />
  );
}
